import React, {useState} from 'react';

import { updateCategory } from 'backend/Category';

const CategoryItem = ({category, index}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [nameEn, setNameEn] = useState(category.name.en);
  const [nameRu, setNameRu] = useState(category.name.ru);
  const [nameUk, setNameUk] = useState(category.name.uk);
  const [namePl, setNamePl] = useState(category.name.pl);
  const [nameIt, setNameIt] = useState(category.name.it);
  const [nameEs, setNameEs] = useState(category.name.es);
  const [namePt, setNamePt] = useState(category.name.pt);

  const [leadEn, setLeadEn] = useState(category.lead.en);
  const [leadRu, setLeadRu] = useState(category.lead.ru);
  const [leadUk, setLeadUk] = useState(category.lead.uk);
  const [leadPl, setLeadPl] = useState(category.lead.pl);
  const [leadIt, setLeadIt] = useState(category.lead.it);
  const [leadEs, setLeadEs] = useState(category.lead.es);
  const [leadPt, setLeadPt] = useState(category.lead.pt);

  const [localNameEn, setLocalNameEn] = useState(category.name.en);
  const [localNameRu, setLocalNameRu] = useState(category.name.ru);
  const [localNameUk, setLocalNameUk] = useState(category.name.uk);
  const [localNamePl, setLocalNamePl] = useState(category.name.pl);
  const [localNameIt, setLocalNameIt] = useState(category.name.it);
  const [localNameEs, setLocalNameEs] = useState(category.name.es);
  const [localNamePt, setLocalNamePt] = useState(category.name.pt);

  const [localLeadEn, setLocalLeadEn] = useState(category.lead.en);
  const [localLeadRu, setLocalLeadRu] = useState(category.lead.ru);
  const [localLeadUk, setLocalLeadUk] = useState(category.lead.uk);
  const [localLeadPl, setLocalLeadPl] = useState(category.lead.pl);
  const [localLeadIt, setLocalLeadIt] = useState(category.lead.it);
  const [localLeadEs, setLocalLeadEs] = useState(category.lead.es);
  const [localLeadPt, setLocalLeadPt] = useState(category.lead.pt);

  const onClickDelete = (id) => {
    alert('TODO: step 2');
  };

  const onClickEdit = () => {
    setIsEdit(!isEdit);
  };

  const onClickSave = (id) => {
    updateCategory(
      id,
      nameEn,
      nameRu,
      nameUk,
      namePl,
      nameIt,
      nameEs,
      namePt,
      leadEn,
      leadRu,
      leadUk,
      leadPl,
      leadIt,
      leadEs,
      leadPt)
      .then(() => {
        setIsEdit(false);
        setLocalNameEn(nameEn);
        setLocalLeadEn(leadEn);

        setLocalNameRu(nameRu);
        setLocalLeadRu(leadRu);

        setLocalNameUk(nameUk);
        setLocalLeadUk(leadUk);
        
        setLocalNamePl(namePl);
        setLocalLeadPl(leadPl);

        setLocalNameIt(nameIt);
        setLocalLeadIt(leadIt);

        setLocalNameEs(nameEs);
        setLocalLeadEs(leadEs);

        setLocalNamePt(namePt);
        setLocalLeadPt(leadPt);
      })
      .catch((error) => {
        console.log('updateCategory error', error);
      });
  };

  const onClickCancel = () => {
    setIsEdit(false);
    setNameEn(localNameEn);
    setLeadEn(localLeadEn);

    setNameRu(localNameRu);
    setLeadRu(localLeadRu);

    setNameUk(localNameUk);
    setLeadUk(localLeadUk);

    setNamePl(localNamePl);
    setLeadPl(localLeadPl);

    setNameIt(localNameIt);
    setLeadIt(localLeadIt);

    setNameEs(localNameEs);
    setLeadEs(localLeadEs);

    setNamePt(localNamePt);
    setLeadPt(localLeadPt);
  };

  const onChangeText = (event, field) => {
    if (field === 'nameEn') setNameEn(event.target.value);
    if (field === 'nameRu') setNameRu(event.target.value);
    if (field === 'nameUk') setNameUk(event.target.value);
    if (field === 'namePl') setNamePl(event.target.value);
    if (field === 'nameIt') setNameIt(event.target.value);
    if (field === 'nameEs') setNameEs(event.target.value);
    if (field === 'namePt') setNamePt(event.target.value);

    if (field === 'leadEn') setLeadEn(event.target.value);
    if (field === 'leadRu') setLeadRu(event.target.value);
    if (field === 'leadUk') setLeadUk(event.target.value);
    if (field === 'leadPl') setLeadPl(event.target.value);
    if (field === 'leadIt') setLeadIt(event.target.value);
    if (field === 'leadEs') setLeadEs(event.target.value);
    if (field === 'leadPt') setLeadPt(event.target.value);
  };

	return (
		<tr style={{backgroundColor: isEdit ? '#EEF4F9' : ''}}>
      <td>{index + 1}</td>
      <td>{category.alias}</td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-nameEn-' + index}
              placeholder="Название категории (EN)"
              value={nameEn}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'nameEn')}
            />
            <br/><br/>
            <input
              type="text"
              id={'form-leadEn-' + index}
              placeholder="Описание категории (EN)"
              value={leadEn}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'leadEn')}
            />
          </div>
        ) : (
          <div>
            <b>{localNameEn}</b>
            <br/>
            {localLeadEn}
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-nameRu-' + index}
              placeholder="Название категории (RU)"
              value={nameRu}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'nameRu')}
            />
            <br/><br/>
            <input
              type="text"
              id={'form-leadRu-' + index}
              placeholder="Описание категории (RU)"
              value={leadRu}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'leadRu')}
            />
          </div>
        ) : (
          <div>
            <b>{localNameRu}</b>
            <br/>
            {localLeadRu}
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-nameUk-' + index}
              placeholder="Название категории (UK)"
              value={nameUk}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'nameUk')}
            />
            <br/><br/>
            <input
              type="text"
              id={'form-leadUk-' + index}
              placeholder="Описание категории (UK)"
              value={leadUk}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'leadUk')}
            />
          </div>
        ) : (
          <div>
            <b>{localNameUk}</b>
            <br/>
            {localLeadUk}
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-nameIt-' + index}
              placeholder="Название категории (IT)"
              value={nameIt}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'nameIt')}
            />
            <br/><br/>
            <input
              type="text"
              id={'form-leadIt-' + index}
              placeholder="Описание категории (IT)"
              value={leadIt}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'leadIt')}
            />
          </div>
        ) : (
          <div>
            <b>{localNameIt}</b>
            <br/>
            {localLeadIt}
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-namePl-' + index}
              placeholder="Название категории (PL)"
              value={namePl}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'namePl')}
            />
            <br/><br/>
            <input
              type="text"
              id={'form-leadPl-' + index}
              placeholder="Описание категории (PL)"
              value={leadPl}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'leadPl')}
            />
          </div>
        ) : (
          <div>
            <b>{localNamePl}</b>
            <br/>
            {localLeadPl}
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-nameEs-' + index}
              placeholder="Название категории (ES)"
              value={nameEs}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'nameEs')}
            />
            <br/><br/>
            <input
              type="text"
              id={'form-leadEs-' + index}
              placeholder="Описание категории (ES)"
              value={leadEs}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'leadEs')}
            />
          </div>
        ) : (
          <div>
            <b>{localNameEs}</b>
            <br/>
            {localLeadEs}
          </div>
        )}
      </td>

      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-namePt-' + index}
              placeholder="Название категории (PT)"
              value={namePt}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'namePt')}
            />
            <br/><br/>
            <input
              type="text"
              id={'form-leadPt-' + index}
              placeholder="Описание категории (PT)"
              value={leadPt}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'leadPt')}
            />
          </div>
        ) : (
          <div>
            <b>{localNamePt}</b>
            <br/>
            {localLeadPt}
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <p>
            <button className="btn btn-success btn-xs" onClick={() => onClickSave(category.alias)}>
              <i className="ace-icon fa fa-save bigger-110 icon-only"></i>
            </button>
            &nbsp;&nbsp;
            <button className="btn btn-grey btn-xs" onClick={() => onClickCancel()}>
              <i className="ace-icon fa fa-reply bigger-110 icon-only"></i>
            </button>
          </p>
        ) : (
          <p>
            <button className="btn btn-warning btn-xs" onClick={() => onClickEdit()}>
              <i className="ace-icon fa fa-pencil-square-o bigger-110 icon-only"></i>
            </button>
            &nbsp;&nbsp;
            <button className="btn btn-grey btn-xs" onClick={() => onClickDelete(category.alias)}>
              <i className="ace-icon fa fa-trash-o bigger-110 icon-only"></i>
            </button>
          </p>
        )}
      </td>
		</tr>
	);
};

export default CategoryItem;
